import { testimonials } from '@/mocks/testimonials';

export default function TestimonialSection() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-2 h-2 rounded-full bg-primary-500"></span>
            <span className="text-[11px] font-label font-medium text-foreground-500 uppercase tracking-wider whitespace-nowrap">
              用户评价
            </span>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-black text-foreground-50">
            漫迷们怎么说
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            来自真实用户的使用体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="bg-background-200/40 rounded-lg p-5 md:p-6 flex flex-col"
            >
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i
                      className={`text-sm ${
                        i < t.rating
                          ? 'ri-star-fill text-primary-400'
                          : 'ri-star-line text-foreground-700'
                      }`}
                    ></i>
                  </div>
                ))}
              </div>
              <h4 className="text-sm font-heading font-bold text-foreground-50 mb-2">
                {t.comment.slice(0, 20)}...
              </h4>
              <p className="text-xs text-foreground-500 leading-relaxed flex-1">
                {t.comment}
              </p>
              <div className="flex items-center gap-3 mt-4 pt-4 border-t border-background-300/30">
                <div className="w-9 h-9 rounded-full overflow-hidden shrink-0">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-xs font-semibold text-foreground-50">{t.name}</p>
                  <p className="text-[10px] text-foreground-600">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}